export default "__VITE_ASSET__DIg4xsEj__"